import { get, post } from '@/api/request'

export interface StripeProductPlan {
    productName: string
    planId: string
    productId: string
    currencySymbol: string
    price: string
    priceFirstPeriod?: string
    dayPrice: string
    dayPriceFirstPeriod?: string
    amountOff?: number | string
    durationType: 'week' | 'month' | 'year' | string
    freeTrialDay: number
}



export const getStripeProductList = (payload?: string) => {
    const searchParams = new URLSearchParams() // searchParams 会自动将参数进行 URL 编码
    if (payload) {
        searchParams.set('payload', String(payload))
    }

    const queryString = searchParams.toString()
    const url = queryString
        ? `/api/solve-x-ai/subs/stripe/product-list?${queryString}`
        : '/api/solve-x-ai/subs/stripe/product-list'
    return get(url)
}


export interface GetStripeCheckinLinkPayload {
    productId: string
    callbackUrl?: string
}

export const getStripeCheckinLink = (payload: GetStripeCheckinLinkPayload) => {
    return post('/api/solve-x-ai/subs/stripe/get-checkin-link', payload)
}

/**
 * Stripe Embedded Checkout：返回 client_secret + publishableKey，
 * 前端用 Stripe.js initEmbeddedCheckout 在弹窗 iframe 内挂载结账。
 * callbackUrl 应传 iframe 自身 URL（return_url 由后端追加 paid_result=1）。
 */
export interface StripeEmbeddedSession {
    clientSecret: string
    publishableKey: string
}

export const getStripeEmbeddedCheckinLink = (payload: GetStripeCheckinLinkPayload) => {
    return post('/api/solve-x-ai/subs/stripe/get-embedded-checkin-link', payload)
}

/**
 * 父代支付（PARENT_PAY）专用：使用 AES 加密 payload 携带 userId + productId + groupCode
 * 与 getStripeCheckinLink 是两个独立流程，不要混用
 */
export const getParentPayStripeCheckinLink = (payload: { payload: string }) => {
    return post('/api/solve-x-ai/subs/stripe/get-checkin-link', payload)
}

export const getStripeSubsMgmtLink = () => {
    return get('/api/solve-x-ai/subs/stripe/get-subs-mgmt-link')
}

